// API配置工具
const isDevelopment = process.env.NODE_ENV === 'development'

// 根据环境确定API基础URL
const getApiBaseUrl = () => {
  if (isDevelopment) {
    // 开发环境使用代理
    return '/api'
  } else {
    // 生产环境使用完整的Workers URL
    // 需要替换为实际的Workers URL
    // 格式: https://WORKER_NAME.SUBDOMAIN.workers.dev
    return 'https://ancient-books-api.hailion1999.workers.dev/'
  }
}

// API基础URL
export const API_BASE_URL = getApiBaseUrl()

// API请求工具函数
export const apiRequest = async (endpoint, options = {}) => {
  // 在开发环境中，使用相对路径和代理
  if (isDevelopment) {
    const url = `/api${endpoint}`
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      }
    }
    
    try {
      const response = await fetch(url, { ...defaultOptions, ...options })
      
      // 检查响应是否为JSON格式
      const contentType = response.headers.get('content-type')
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text()
        throw new Error(`服务器返回非JSON响应: ${text.substring(0, 100)}...`)
      }
      
      return response
    } catch (error) {
      console.error(`API请求失败 ${url}:`, error)
      throw error
    }
  } else {
    // 在生产环境中，使用完整的URL
    const url = `${API_BASE_URL}${endpoint}`
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      }
    }
    
    try {
      const response = await fetch(url, { ...defaultOptions, ...options })
      
      // 检查响应是否为JSON格式
      const contentType = response.headers.get('content-type')
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text()
        throw new Error(`服务器返回非JSON响应: ${text.substring(0, 100)}...`)
      }
      
      return response
    } catch (error) {
      console.error(`API请求失败 ${url}:`, error)
      throw error
    }
  }
}